import { IconInfoCircle } from "@tabler/icons-react";
import { RibbonButton } from "@tredespace/ui/widgets";
import { type JSX, useState } from "react";
import { AboutDialog } from "../AboutDialog.tsx";

/** Only this button opens the dialog, so its state stays local. */
export function AboutButton(): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <RibbonButton
        icon={<IconInfoCircle />}
        label="About"
        size="big"
        onClick={() => setIsOpen(true)}
        tooltip={`HAKI Spira v${__APP_VERSION__}\nVersion, dependencies and credits`}
      />
      {isOpen && <AboutDialog onDismiss={() => setIsOpen(false)} />}
    </>
  );
}
